import { render, staticRenderFns } from "./ViqGapQuestions.vue?vue&type=template&id=7f859d59&scoped=true"
import script from "./ViqGapQuestions.vue?vue&type=script&lang=js"
export * from "./ViqGapQuestions.vue?vue&type=script&lang=js"
import style0 from "./ViqGapQuestions.vue?vue&type=style&index=0&id=7f859d59&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f859d59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f859d59')) {
      api.createRecord('7f859d59', component.options)
    } else {
      api.reload('7f859d59', component.options)
    }
    module.hot.accept("./ViqGapQuestions.vue?vue&type=template&id=7f859d59&scoped=true", function () {
      api.rerender('7f859d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqGapQuestions.vue"
export default component.exports